import React from 'react';
import styled from 'styled-components';
import colors from 'constants/styles/colors';

const SCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const SImageWrapper = styled.div`
    width: 100%;
    max-width: 340px;
    max-height: 340px;
    border-radius: 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    background: ${colors.gray_10};
`;

const SImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

const SName = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0.01em;
    margin-bottom: 6px;
`;

const SRole = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    letter-spacing: 0.01em;
    text-align: center;
`;

interface Props {
    imageSrc: string;
    alt: string;
    name: string;
    role: string;
}

export const TeamMemberCard = ({ imageSrc, alt, name, role }: Props) => {
    return (
        <SCard>
            <SImageWrapper>
                <SImage src={imageSrc} alt={alt} />
            </SImageWrapper>
            <SName>{name}</SName>
            <SRole>{role}</SRole>
        </SCard>
    );
};
